"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SalesByProductOrder {
    constructor({ target, direction }) {
        this.toJSON = () => ({
            target: this.target,
            direction: this.direction,
        });
        this.target = target;
        this.direction = direction;
    }
}
SalesByProductOrder.fromJSON = (json) => {
    const { target, direction } = Object.assign({}, json);
    if (target !== 'value' && target !== 'quantity')
        throw new Error('.target must be a SalesByProductOrderTarget');
    if (direction !== 'asc' && direction !== 'desc')
        throw new Error('.direction must be a OrderDirection');
    return new SalesByProductOrder({
        target,
        direction,
    });
};
exports.default = SalesByProductOrder;
